// form-include
// フォームのページだけsslの改装にしてるときにヘッダーとフッター共通化
jQuery(function($) {
  if ($('#is-exform').length) {
    // console.log('external form page');
    var $bodyArea = $('#js-bodyArea');
    var $defer = new $.Deferred();
    var _includeCounter = 0;
    var includeParts = function(file) {
      $.ajax({
        type: 'GET',
        url: file,
        dataType: 'html',
        success: function(data) {
          if (file.indexOf('header') !== -1) {
            $bodyArea.prepend(data);
          } else if (file.indexOf('footer') !== -1) {
            $bodyArea.append(data);
          }
          _includeCounter ++;
          if (_includeCounter >= 2) {
            $defer.resolve();
          }
        },
        error: function() {
          console.log('ajax faild');
        }
      });
      return $defer.promise();
    };
    $.when(
      includeParts('include/header.html'),
      includeParts('include/footer.html')
    )
    .done(function() {
      // 変数 ナビ系
      var $modalNav = $('#js-gnav');
      var $trigger = $('#js-gnav-trigger');
      // 変数 ヘッダー背景
      var
        $win = $(window),
        $header = $('#js-header'),
        _className = 'has-bg',
        _winPos = $win.scrollTop();

      // 処理 ナビ系
      if ($modalNav.length && $trigger.length) {
        var $closeTrigger = $('#js-gnav > ul a, #js-modal-layer');
        var $layer = $('#js-modal-layer');
        var $body = $('body');
        $trigger.on('click', function() {
          $(this).toggleClass('is-active');
          if ($(this).hasClass('is-active')) {
            $modalNav.addClass('is-active');
            $body.addClass('gnav-is-active');
            $layer.addClass('is-active');
          } else {
            $modalNav.removeClass('is-active');
            $body.removeClass('gnav-is-active');
            $layer.removeClass('is-active');
          }
        });
        $closeTrigger.on('click', function() {
          $modalNav.removeClass('is-active');
          $layer.removeClass('is-active');
          $trigger.removeClass('is-active');
          $body.removeClass('gnav-is-active');
        });
        console.log('gnav is exist (ajax)');
      } else {
        console.log('gnav is not exist (ajax)');
      }

      // 処理 ヘッダー背景
      if (_winPos > 100) {
        $header.addClass(_className);
      } else {
        $header.removeClass(_className);
      }
      window.addEventListener('scroll', function() {
        _winPos = $win.scrollTop();
        if (_winPos > 100) {
          $header.addClass(_className);
        } else {
          $header.removeClass(_className);
        }
      }, false);
    });
  }
});
